import React from 'react'
import { usePutRequest } from '../../../hooks/request'
import MarketForm from './MarketForm'

export default function MarketUpdate({ onCancel, onSuccess, item, }) {
    const brandUpdate = usePutRequest({ url: '/main/market/{id}'.replace('{id}', item.id) })

    async function onSubmit(data) {
        const { success } = await brandUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Ўзгартириш</b>
            </h1>
            <MarketForm loading={brandUpdate.loading} initialValues={item} onSubmit={onSubmit}
                onCancel={onCancel} />
        </div>
    )
}
